import { useCallback, useEffect, useState } from "react";
import { CustomButton } from "../../../../components/CustomButton";
import { ContainerHorarios, IconButton, Schedule, ScheduleField, ScheduleStatus } from "./styles";
import api from "../../../../services/api";
import EditarCadastrarHorarioBanner from "./EditarCadastrar";
import { FaEdit } from "react-icons/fa";
import { daysLabels } from "../../../../constants/daysLabels";

const HorariosBanner = ({ banner }) => {
  const [schedules, setSchedules] = useState([]);
  const [schedule, setSchedule] = useState();
  const [modalCreate, setModalCreate] = useState(false);

  const loadSchedules = useCallback(async () => {
    if (banner.Id) {
      const { data } = await api.get(`horarios-banner/listar/${banner.Id}`);
      if (data?.length > 0) {
        setSchedules(data);
      }
    }
  }, []);

  useEffect(() => {
    loadSchedules();
  }, []);

  return (
    <>
      <ContainerHorarios>
        <CustomButton
          appearance="primary"
          onClick={() => {
            setSchedule(null);
            setModalCreate(true)
          }}>
          Adicionar Horário
        </CustomButton>
        {schedules.map((item) => (
          <Schedule key={item.Id}>
              <ScheduleField>{daysLabels[item?.Dia]}</ScheduleField>
              <ScheduleField>{item.Inicio}</ScheduleField>
              <ScheduleField>{item.Fim}</ScheduleField>
              <ScheduleStatus status={item.Ativo}>{item.Ativo ? 'Ativo' : 'Inativo'}</ScheduleStatus>
              <ScheduleField>
                  <IconButton onClick={() => { setSchedule(item); setModalCreate(true) }}>
                      <FaEdit size={12} />
                  </IconButton>
              </ScheduleField>
          </Schedule>
      ))}
      </ContainerHorarios>
      {modalCreate && <EditarCadastrarHorarioBanner
        open={modalCreate}
        handleClose={() => setModalCreate(false)}
        schedule={schedule}
        banner={banner}
        setSchedules={setSchedules}
      />}
    </>
  );
}

export default HorariosBanner;